<script>
import formtextarea from "@/router/views/FormComponet/formtextarea.vue";
import formcombobox from "../../FormComponet/formcombobox.vue";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfTablolarDetay from "@/models/StrPerfTablolarDetay"; 
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  mixins: [Api, Sabit, StrPerfTablolarDetay],
  props: ["Id", "AddEdit","DonemId"],
  data() {
    return {
      ComboboxTablolar: [],
      gostergelist:[],
      secilen_gosterge: null,
      secilen_donem: null,
      tablolar: [],
      donemler: [],
      secilen_tablolar: null,
       gostergeler: [],
      FormData: {},
      gostergelistesi:[],
    };
  },
  components: {
    Loader,
   formtextarea,
    Treeselect,
    formcombobox

  },
  watch: {
    Id() {
      this.FormData = this.Id;
      this.Get();
    },
  },
  methods: {
    Get(){


      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };



      this.ActionsGet({"Service":"StrPerfTablolarDetay", "Page":Page}).then((res1) => { 
        this.gostergelistesi =  res1.Data;
      });

        
      let sorgu = "&Tip=1561";
      let Tip=[];
            this.ActionsFilterGet({Service:"OKeyValues", Page:Page, Filter:sorgu}).then((res) => {
              console.log(res)
                for(var i=0; i<res.Data.length; i++)
                {   
                    if(res.Data[i].Kod==1 || res.Data[i].Kod==2 ) { 
                        Tip.push(res.Data[i].Id);       
                    }            
                }
                let altsorgu="&UstIdDoluMu=false&Approval=true";
                let tipler="";
                for (var s=0; s<Tip.length; s++){
                    tipler=tipler+"&TipId="+Tip[s];
                }
                altsorgu=altsorgu+tipler;
  

                this.ActionsFilterGet({ Service: "StrPerfDonem", Page: Page, Filter: altsorgu }).then((res) => {
                for (var i = 0; i < res.Data.length; i++) {
            
                   
                    this.donemler.push ({id:res.Data[i].Id,label:res.Data[i].Aciklama})
                  
                }
              });
         
            });
 

      
    },

      formul_goster(formul){

      let hesaplanacak =formul;
      let karakter1;
      let karakter2;
        if(hesaplanacak!=null) {
            for (var i=0; i<hesaplanacak.length; i++){  
              
              if(hesaplanacak[i]=="{"){karakter1=i+1;}
              if(hesaplanacak[i]=="}"){
                karakter2=i;

                  for (var k=0;k<this.gostergelistesi.length;k++){

                    if (this.gostergelistesi[k].Id==hesaplanacak.substring(karakter1,karakter2)){

                      formul=formul.replaceAll("{"+this.gostergelistesi[k].Id+"}",this.gostergelistesi[k].Gostergesi);

                    }

                  }
              }

            }
        }

      return formul;
      
    },
    tablo_yukle() {
          if (this.secilen_donem.length > 0) {
            let  Sorgu =  "&Asc=SiraNo&DonemId=" + this.secilen_donem;
            let Page = {
              PageNumber: "1",
              PageSize: "9999",
            };
            let Filter = Sorgu;
            this.ActionsFilterGet({ Service: "StrPerfTablo", Page: Page, Filter: Filter }).then((res) => {
              this.tablolar = [];
              this.ComboboxTablolar = res.Data;
              for (var i = 0; i < this.ComboboxTablolar.length; i++) {
                this.tablolar.push({ id: this.ComboboxTablolar[i].Id, label: this.ComboboxTablolar[i].Adi });
              }

            });
          } else {
            this.tablolar = [];
      
          }

    },
 gosterge_yukle() {
      let Sorgu = "&Aktif=true";

          if (this.secilen_tablolar.length > 0) {
          
              Sorgu = Sorgu + "&Tabloids=" + this.secilen_tablolar;
            

            let Page = {
              PageNumber: "1",
              PageSize: "9999",
            };
            this.gostergelist=[];
            let Filter = Sorgu;
            this.ActionsFilterGet({ Service: "StrPerfTablolarDetay", Page: Page, Filter: Filter }).then((res) => {
              this.gostergeler =  res.Data;
this.gostergelist=[];
              for (var i = 0; i < this.gostergeler.length; i++) {
                  this.gostergelist.push({ id: this.gostergeler[i].Id, label: this.gostergeler[i].Gostergesi });
              }

            });
          } else {
            this.gostergeler = [];
      
          }

    },

 formul_duzenle(gosterge){
  if (gosterge!=null && gosterge!=""){

   this.FormData.FormulIcerik=this.FormData.FormulIcerik+"{"+gosterge+"}";
  }
 },

 operator_ekle(operator){
  if (operator!=null && operator!=""){
   this.FormData.FormulIcerik=this.FormData.FormulIcerik+operator;
  }

 },

    onSubmit() {

      this.$bvModal.hide("FormulOLustur");
 
    },
  },


};
</script>
<template>


  <Loader>

  
    <b-modal
      id="FormulOLustur"
      size="lg"
       :title="$t('FormulOlustur.Title')"
      title-class="font-18"
      hide-footer
    >


  <Form  @submit.prevent="onSubmit" > 
                       <div class="row">
                         <div class="col-md-12">

                       
                  <formcombobox
                    :title_position="'d-block'"
                    :labels_lg="8"
                    :FormDataType="FormDataType.Formulduzey"
                    :Value="FormData.Formulduzey"
                    :v="$v.FormData.Formulduzey"
                    @input="FormData.Formulduzey = $event"
                  />
                  <b-form-group class="d-block" id="example text" label-cols-lg="2" label="Dönemler" label-for="text">
                <treeselect :multiple="false" :options="donemler" placeholder="Seçiniz..." 
                v-model="secilen_donem" @input="tablo_yukle()"  />
                <treeselect-value :value="secilen_tablolar" />
              </b-form-group> 

               <b-form-group class="d-block" id="example text" label-cols-lg="2" label="Tablolar" label-for="text">
                <treeselect :multiple="false" :options="tablolar" placeholder="Seçiniz..." 
                v-model="secilen_tablolar" @input="gosterge_yukle()"  />
                <treeselect-value :value="secilen_tablolar" />
              </b-form-group>   

               <b-form-group class="d-block" id="example text" label-cols-lg="2" label="Göstergeler" label-for="text">
                <treeselect :multiple="false" :options="gostergelist" placeholder="Seçiniz..." 
                v-model="secilen_gosterge" @input="formul_duzenle(secilen_gosterge)"  />
                <treeselect-value :value="secilen_gosterge" />
              </b-form-group>   

              <hr>

               <formtextarea
                              :FormDataType="FormDataType.FormulIcerik"
                              :Value="FormData.FormulIcerik"
                              :v="$v.FormData.FormulIcerik"
                              @input="FormData.FormulIcerik = $event"
                            />

                             <div class="action-is w-100 d-flex justify-content-center align-items-center">
                              <i style="margin-left:10px" class="fas fa-plus"  @click="operator_ekle('+')"> </i>
                              <i style="margin-left:10px" class="fas fa-minus"  @click="operator_ekle('-')"> </i>
                              <i style="margin-left:10px" class="fas fa-times"  @click="operator_ekle('*')"> </i>
                               <i style="margin-left:10px" class="fas fa-divide"  @click="operator_ekle('/')"> </i>
                          
                             
                             
                            </div>
                            <hr>
                            <table>
                              <tr><th>Formül</th></tr>
                              <tr><td> {{formul_goster(FormData.FormulIcerik)}}</td></tr>
                            </table>

                            <hr>
            

                       
                            <button class="btn btn-primary"  type="submit" >{{ $t("FormulOlustur.Button") }}</button> 

                        
                         </div>
                            </div>

                
                          </Form>    
                          <br>

                   <!-- <table class="table table-striped table-bordered mb-0">
      <thead>
        <tr>
          <th scope="col">{{ $t("StrPerfTablolarDetay.Table.Gostergesi") }}</th>
          <th scope="col">{{ $t("StrPerfTablolarDetay.Table.Islem") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="HedefKartlariDetay in gostergeler" :key="HedefKartlariDetay.Id">
          <td>{{ HedefKartlariDetay.Gostergesi }}</td>
         

          <td style="width:100px">
            <div class="action-is w-100 d-flex justify-content-center align-items-center">

              <i style="margin-left:10px" class="fas fa-plus"  @click="formul_duzenle(HedefKartlariDetay.Id)"> </i>

            
            </div>
          </td>
        </tr>
      </tbody>
    </table>   -->                          
                       


    </b-modal>
  </Loader>
</template>
